import { forEach } from 'lodash-es';

import { Campaign, CampaignStatus, CampaignType, CampaignAutomation } from '@dev/ee-api/ee-api-models';

import { store } from '@shared-store/shared-store';
import { CampaignStatusCounts } from '@/store/campaigns/types';
import { TotalEventHeaders } from '@/services/dictionaries/Headers';
import { LONG_DATE_FORMAT } from '@/services/constants';
import dayjs from '@/services/tools/dayjs';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const extractStatusCounts = (headers: any): CampaignStatusCounts => ({
    total: Number(headers[TotalEventHeaders.TotalCount]) || 0,
    active: Number(headers[TotalEventHeaders.ActiveCount]) || 0,
    cancelled: Number(headers[TotalEventHeaders.CancelledCount]) || 0,
    completed: Number(headers[TotalEventHeaders.CompletedCount]) || 0,
    deleted: Number(headers[TotalEventHeaders.DeletedCount]) || 0,
    draft: Number(headers[TotalEventHeaders.DraftCount]) || 0,
    paused: Number(headers[TotalEventHeaders.PausedCount]) || 0,
    processing: Number(headers[TotalEventHeaders.Processing]) || 0,
    sending: Number(headers[TotalEventHeaders.SendingCount]) || 0,
});
/* eslint-enable @typescript-eslint/explicit-module-boundary-types */

export const isCampaignDeleteAllowed = (campaign: Campaign): boolean =>
    campaign.Status === CampaignStatus.Sending || campaign.Status === CampaignStatus.Processing;

export const getActiveCampaignNames = (campaignNames: string[], collection?: Campaign[]): string[] => {
    if (!collection) {
        collection = store.getState().campaigns.collection;
    }

    const activeCampaignNames = [];

    forEach(collection, (campaign: Campaign): void => {
        if (isCampaignDeleteAllowed(campaign) && campaignNames.includes(campaign.Name)) {
            activeCampaignNames.push(campaign.Name);
        }
    });

    return activeCampaignNames;
};

export const getUsedInAutomationsCampaignNames = (campaignNames: string[], collection?: Campaign[]): string[] => {
    if (!collection) {
        collection = store.getState().campaigns.collection;
    }

    const usedCampaignNames = [];

    forEach(collection, (campaign: Campaign): void => {
        if (campaign.CampaignAutomations && campaignNames.includes(campaign.Name)) {
            usedCampaignNames.push(campaign.Name);
        }
    });

    return usedCampaignNames;
};

export const getAutomationNamesUsingPickedCampaigns = (campaignNames: string[], collection?: Campaign[]): string[] => {
    if (!collection) {
        collection = store.getState().campaigns.collection;
    }

    const automationNames = [];

    forEach(collection, (campaign: Campaign): void => {
        if (campaign.CampaignAutomations && campaignNames.includes(campaign.Name)) {
            forEach(campaign.CampaignAutomations, (automation: CampaignAutomation): void => {
                automationNames.push(automation.Name);
            });
        }
    });

    return automationNames;
};

export const getDefaultSummaryReportToDate = (campaign: Campaign): string =>
    campaign.Type === CampaignType.Automated
        ? dayjs().format(LONG_DATE_FORMAT)
        : dayjs(campaign?.TriggerOptions?.DateToSendOn).add(2, 'd').format(LONG_DATE_FORMAT);

export const getABTestNameByIndex = (index: number): string => {
    const alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
    return alphabet[index];
};
